import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { Box, Card, Grid, Stack, Typography } from '@mui/material'
import { ClassNameMap, withStyles } from '@mui/styles'
import { RootState, useAppThunkDispatch } from "../../../../redux/store";
import { setSelectedPU, setSelectedSchedule } from '../../../../redux/common-data-slice'
import stylesheet from "../detail-container.stylesheet";
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined'
import { checkCondition } from '../common/condition-check';
interface IProps {
  key: string
  data: any,
  outerSubmit: any,
  compKey: string,
  mapState: any,
  is_discontinued?: boolean,
  classes: ClassNameMap
}

const ScheduleCarePlanDialogComponent: React.FC<IProps> = ({ key, data, outerSubmit, compKey, mapState, is_discontinued = false, classes }) => {
  const uiResource = useSelector((state: RootState) => state.metaData.metadata)
  const [schedulesData, setSchedulesData] = useState(mapState.has('c_rec_schedules') ? mapState.get('c_rec_schedules') : data?.c_rec_schedules || []);
  const [activeCard, setActiveCard] = useState({ key: '', name: '' });
  const [chosenSchedule, setChosenSchedule] = useState(false)
  const [chosenPU, setChosenPU] = useState(false)
  const [puSchedulesData, setPuSchedulesData] = useState(mapState.has('pu_recs') ? mapState.get('pu_recs') : []);
  const dispatch = useAppThunkDispatch();
  const selectedSchedule = useSelector((state: RootState) => state.commonData.selectedSchedule)
  const selectedPU = useSelector((state: RootState) => state.commonData.selectedPU)

  useEffect(() => {
    if (data?.is_recommended) {
      const activeScheduleName = selectedSchedule?.name || data?.aa_rec?.name
      let activeSch = schedulesData?.find((c: any) => c.name === activeScheduleName)
      if (activeSch !== undefined)
        setActiveCard({ key: activeSch.name, name: activeSch?.schedule_display_name })
    } else {
      const activeScheduleName = selectedSchedule?.name || data?.c_schedule?.name
      let activeSch = schedulesData?.find((c: any) => c.name === activeScheduleName)
      if (activeSch !== undefined)
        setActiveCard({ key: activeSch.name, name: activeSch?.schedule_display_name })
    }
  }, [])

  useEffect(() => {
    if (activeCard && activeCard?.key !== '') {
      const temp = schedulesData?.map((m: any) => m.name === activeCard.key ? { ...m, chosen: true } : { ...m, chosen: false })
      setSchedulesData(temp)
      if (chosenSchedule) {
        const currSch = schedulesData?.filter((m: any) => m.name === activeCard.key)?.[0] || {}
        outerSubmit(compKey, temp)
        dispatch(setSelectedSchedule(currSch))
      }

      const currSchName = activeCard?.key
      const puList = !chosenSchedule && puSchedulesData?.length > 0
        ? puSchedulesData : data?.pu_recs?.[currSchName] || []
      if (data?.is_recommended) {
        setPuSchedulesData(puList)
        const activePUrxcui = selectedPU?.rxcui !== ''
          ? selectedPU?.rxcui
          : (activeCard?.key === data?.aa_rec?.name)
            ? puList?.find((i: any) => i.rxcui === data?.pu_rec?.rxcui)?.rxcui
            : puList?.find((i: any) => i.chosen)?.rxcui

        onPUCardSelection(activePUrxcui || '', puList)
      }
    }
  }, [activeCard])

  const onCardSelection = (_name: string) => {
    setChosenSchedule(true)
    const currChosenSch = schedulesData?.filter((m: any) => m.name === _name)?.[0] || {}
    const activeSch = { key: currChosenSch.name, name: currChosenSch?.schedule_display_name }
    setActiveCard(activeSch)
  }

  const onPUCardSelection = (rxcui: string, puList: any) => {
    if (rxcui !== '') {
      setChosenPU(true)
      const currPUdata = Object.keys(puList)?.length > 0 ? puList : data?.pu_recs[activeCard.key]
      const curr_pu_rec = currPUdata?.map((m: any) => m.rxcui === rxcui ? { ...m, chosen: true } : { ...m, chosen: false })
      setPuSchedulesData(curr_pu_rec)
      if (!chosenSchedule)
        outerSubmit(compKey, schedulesData)

      outerSubmit('pu_recs', [...curr_pu_rec])
      dispatch(setSelectedPU(currPUdata.find((m: any) => m.rxcui === rxcui)))
    }
  }

  const getConditionsList = (value: any) => {
    let isCriteria = false
    let val = value?.condition || []
    let dir = is_discontinued ? value?.directions?.dc || "-" : value?.directions?.init || "-"
    const checkCriteria = (flag: boolean) => {
      if (flag) isCriteria = true
    }

    const conditions = Object.keys(val)?.map((i: any, index: any) => {
      if (typeof (val[i]) === 'object') {
        const currItem = val[i]
        return Object.keys(currItem)?.map((item: any, indx: any) => {
          if (!isCriteria) checkCriteria(currItem[item])

          return <Typography component="span" className={classes.scheduleDoseInfo} sx={{ lineHeight: 1.1 }}>
            <Typography component="span" className={classes.scheduleDoseInfo} sx={{ lineHeight: 1.1 }} color={!currItem[item] ? 'error' : 'green'}>
              <small>{item}</small>
            </Typography>
            {(Object.keys(currItem)?.length > (indx + 1) || Object.keys(val)?.length > (index + 1)) && ', '}
          </Typography>
        })
      }
      else {
        if (!isCriteria) checkCriteria(val[i])

        return <Typography component="span" className={classes.scheduleDoseInfo} sx={{ lineHeight: 1.1 }}>
          <Typography component="span" className={classes.scheduleDoseInfo} sx={{ lineHeight: 1.1 }} color={!val[i] ? 'error' : 'green'}>
            <small>{i}</small>
          </Typography>
          {Object.keys(val)?.length > (index + 1) && ', '}
        </Typography>
      }
    })

    return <>
      <Typography className={classes.scheduleDoseInfo} sx={{ lineHeight: 1.1 }}>
        <small>{'Directions :'} </small>
        <Typography component='span' className={classes.scheduleDoseInfo} sx={{ lineHeight: 1.1 }}>
          <small>{dir}</small>
        </Typography>
      </Typography>
      <Typography className={classes.scheduleDoseInfo} sx={{ lineHeight: 1.1 }}>
        <small>{'Condition criteria met?'} </small>
        <Typography component='span' className={classes.scheduleDoseInfo} sx={{ lineHeight: 1.1 }} color={isCriteria ? 'green' : 'red'}>
          <small>{isCriteria ? 'YES' : 'NO'}</small>
        </Typography>
      </Typography>
      <Typography className={classes.scheduleDoseInfo} sx={{ lineHeight: 1.1 }}>{conditions}</Typography>
    </>
  }

  const renderScheduleDetails = (label: any, val: any, caution = false) => {
    return <Grid item>
      <Typography variant="subtitle2"><small>{label}:</small>
        {label === 'Conditions'
          ? <Typography component='span' variant="subtitle2" style={{ paddingLeft: '0.2rem' }}>
            {getConditionsList(val)}
          </Typography>
          : <Typography
            component='span'
            variant="subtitle2"
            color={['Next dose', 'Next frequency'].includes(label) && val === 'None' ? 'secondary' : 'inherit'}
            style={{ paddingLeft: '0.2rem' }}
          >
            <small>{val}</small>
          </Typography>
        }
      </Typography>
    </Grid>
  }

  const getDose = (dose: any, unit: any, freq: any) => dose === 'NA' ? 'NA' : `${dose} ${unit} ${freq}`

  const getDoseFreq = (dose: any, freq: any) => {
    return typeof (dose) === 'object' ? `[${dose?.join(', ')}]${freq}` : `${dose}${freq}`
  }

  const tableFormation = (e: any) => {
    return (
      <Box sx={{ padding: '0.15rem 0.25rem' }}>
        <Box>
          <Typography className={classes.scheduleTitle} variant="subtitle2" sx={{ lineHeight: 1.2 }}>
            {e.schedule_display_name || e.name}
            {e.recommended && <CheckCircleOutlineOutlinedIcon className={classes.recommendedCheckCircle} titleAccess="Recommended" />}
          </Typography>
          <Typography className={classes.scheduleDoseInfo} color="GrayText" sx={{ lineHeight: 1.1 }}>
            <small>take {e.route === 'oral' ? 'orally' : e.route}</small>
          </Typography>
        </Box>
        <Box pt={0.1} pb={0.1}>
          {Object.keys(e?.steps || {})?.map((i: any) => (
            <Stack direction={'row'} spacing={0} sx={{ lineHeight: 1.1 }}>
              {i === getDoseFreq(e.starting_dose, e.starting_frequency) && i === getDoseFreq(e.ending_dose, e.ending_frequency) ? (
                <Typography className={classes.scheduleIcon} sx={{ lineHeight: 1.1 }}>
                  &#8596;
                </Typography>
              ) : i === getDoseFreq(e.starting_dose, e.starting_frequency) ? (
                <Typography className={classes.scheduleIcon} sx={{ lineHeight: 1.1 }}>
                  &#x2192;
                </Typography>
              ) : i === getDoseFreq(e.ending_dose, e.ending_frequency) ? (
                <Typography className={classes.scheduleIcon} sx={{ lineHeight: 1.1 }}>
                  &#x2190;
                </Typography>
              ) : (
                ''
              )}
              <Typography className={classes.scheduleDoseInfo} sx={{ lineHeight: 1.1 }}>
                <small>
                  {e?.steps[i]}
                  {(i === getDoseFreq(e.dose, e.frequency) || (data?.aa_rec?.name === e.name && data.titration_status === 'uptitrate' && i === getDoseFreq(e.prior_dose, e.prior_frequency))) && ' - '}
                </small>
              </Typography>
              <Typography
                className={classes.scheduleDoseInfo}
                sx={{
                  lineHeight: 1.1,
                  paddingLeft: '0.2rem',
                  color:
                    i === getDoseFreq(e.dose, e.frequency)
                      ? 'green'
                      : data?.aa_rec?.name === e.name && data.titration_status === 'uptitrate' && i === getDoseFreq(e.prior_dose, e.prior_frequency)
                      ? 'red'
                      : 'inherit',
                }}
              >
                <small>
                  {i === getDoseFreq(e.dose, e.frequency)
                    ? data?.is_recommended
                      ? 'start'
                      : 'current'
                    : data?.aa_rec?.name === e.name && data.titration_status === 'uptitrate' && i === getDoseFreq(e.prior_dose, e.prior_frequency)
                    ? 'stop'
                    : ''}
                </small>
              </Typography>
            </Stack>
          ))}
        </Box>
        {getConditionsList(e)}

        {/* {renderScheduleDetails('Prior dose', getDose(e?.prior_dose, e?.unit, uiResource.MEDICATION_DOSAGE_FREQUENCY[e.frequency]))}
        {renderScheduleDetails('Next dose', getDose(e?.next_dose, e?.unit, uiResource.MEDICATION_DOSAGE_FREQUENCY[e?.next_frequency]))}
        {renderScheduleDetails('Ending dose', getDose(e?.ending_dose, e?.unit, uiResource.MEDICATION_DOSAGE_FREQUENCY[e?.ending_frequency]))}
        {renderScheduleDetails('Next titration interval', e?.nextstep_days || 'NA')}
        {renderScheduleDetails('Conditions', e?.condition || [], e?.caution)}
        {renderScheduleDetails('Dose 0', getDose(e?.starting_dose, e?.unit, uiResource.MEDICATION_DOSAGE_FREQUENCY[e?.starting_frequency]))} */}
      </Box>
    )
  }

  const puTableFormation = (e: any) => {
    return <Box sx={{ padding: '0.15rem 0.25rem' }}>
      <Stack direction="column" spacing={0}>
        <Typography className={classes.scheduleTitle} variant="subtitle2" sx={{ lineHeight: 1.2 }}>
          {e.name} {e.status === 'preferred' &&
            <CheckCircleOutlineOutlinedIcon className={classes.recommendedCheckCircle} titleAccess='System Preferred' />
          }
        </Typography>
        <Typography className={classes.scheduleDoseInfo} sx={{ lineHeight: 1.1 }}>
          <small>{e?.num_units} {e?.formulation_display_name}</small>
        </Typography>
        <Typography className={classes.scheduleDoseInfo} sx={{ lineHeight: 1.1 }}>
          <small>{uiResource.MEDICATION_DOSAGE_FREQUENCY[e.frequency]}</small>
        </Typography>
      </Stack>
    </Box>
  }

  const getScheduleStatus = (e: any) => (e.chosen === true)


  const getPUStatus = (e: any) => {
    if (e.chosen === true) {
      dispatch(setSelectedPU(e))
      return true
    }
  }

  return (
    <Box mb={0.5} className={classes.fullWidth}>
      {(data?.titration_status)?.includes('discontinue')
        ? <Box p={1} pt={0}>
          <Typography variant='subtitle2'>
            {checkCondition(Object.keys(data.pu_order).length !== 0, data.pu_order?.name && `Stop ${data.pu_order?.name}`, '')}
          </Typography>
        </Box>
        : <Box p={0.5} pt={0}>
          <Typography variant="subtitle2" className={classes.puSchedulePadding}>
            Schedules for {data?.name}
          </Typography>
          <Grid container spacing={0.5}>
            {schedulesData?.map((e: any, i: any) =>
              <Grid key={i} item sm={4}>
                <Card variant="outlined"
                  onClick={() => (data?.titration_status &&
                    (data?.titration_status)?.includes('downtitrate')
                    || (data?.titration_status)?.includes('discontinue')
                    || (data?.titration_status)?.includes('prior dose')
                    || (data?.titration_status)?.includes('lowest dose')
                  ) ? undefined
                    : (!e.non_titratable)
                      ? onCardSelection(e.name)
                      : undefined}
                  className={getScheduleStatus(e)
                    ? classes.selectedScheduleCardLayout
                    : (e.non_titratable || (
                      (data?.titration_status)?.includes('downtitrate')
                      || (data?.titration_status)?.includes('discontinue')
                      || (data?.titration_status)?.includes('prior dose')
                      || (data?.titration_status)?.includes('lowest dose')
                    ))
                      ? classes.nonSelectedScheduleCardLayout
                      : classes.scheduleCardLayout
                  }
                >
                  {tableFormation(e)}
                </Card>
              </Grid>
            )}
            {puSchedulesData && puSchedulesData.length > 0 &&
              <Box mb={0.5} className={classes.fullWidth}>
                <Box p={0.5} pt={1} >
                  <Typography variant="subtitle2" className={classes.puSchedulePadding}>
                    Prescription Unit choices for {activeCard?.name}
                  </Typography>
                  <Grid container spacing={0.5}>
                    {puSchedulesData?.map((e: any, index: any) =>
                      <Grid key={index} item sm={4}>
                        <Card variant="outlined"
                          onClick={() => onPUCardSelection(e.rxcui, [])}
                          className={getPUStatus(e)
                            ? classes.selectedScheduleCardLayout
                            : classes.grayScheduleCardLayout}
                        >
                          {puTableFormation(e)}
                        </Card>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </Box>
            }
          </Grid>
        </Box>
      }
    </Box>
  )
}

export default React.memo(withStyles(stylesheet)(ScheduleCarePlanDialogComponent));
